import { TitleButtonDivider } from '@/common/buttons/TitleButtonDivider';
import { EntityPerspective } from '@/common/entityFramework/entityPerspective/EntityPerspective';
import { MassOverwriteButton } from '@/common/entityFramework/entityPerspective/overwrite/MassOverwriteButton';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useEffect, useRef, useState } from 'react';

export const AbvPbmLiabPerspective = ({ overUnderScenId }) => {
  const entityPerspectiveRef = useRef();

  const rsrc = useRsrc();
  const module = useModuleFromRoute();
  const [earnedPeriodIds, setEarnedPeriodIds] = useState(null);

  const entity = 'PBM_LIAB';

  const views = [
    {
      name: 'Over/(Under)',
      dims: ['OVER_UNDER_SCEN', 'EARNED_PERIOD', 'CHANNEL', 'PBM', 'PROD'],
      kpis: [
        'ACCR_AMT',
        'PYMT_AMT',
        'PYMT_ADJ',
        'TOTAL_PYMT',
        'FORECASTED_LIAB',
        'LIAB_ADJ',
        'ACTIVITY',
        'PROJ_PYMT_AMT',
        'OVER_UNDER',
      ],
      disabledDims: ['OVER_UNDER_SCEN'],
      numFrozenDims: 1,
      dimToPeriodicities: {
        EARNED_PERIOD: ['LIFETIME', 'YEAR', 'QTR'],
      },
    },
  ];

  useEffect(() => {
    rsrc
      .data(module, 'OVER_UNDER_SCEN_VAL_QTR_DATA_PLUGIN', { entity, overUnderScenId }, entity)
      .then((res) => setEarnedPeriodIds(res));
  }, [overUnderScenId]);

  if (earnedPeriodIds === null) return null;

  const defaultDimFilters = { OVER_UNDER_SCEN: [overUnderScenId], EARNED_PERIOD: earnedPeriodIds };

  const getContextMenuItems = (params) => {
    let contextMenus = entityPerspectiveRef.current.getContextMenuItems(params);

    const pymtItems = [
      {
        name: 'Payment Amounts',
        action: () =>
          entityPerspectiveRef.current.navigateToViewer(
            params,
            'PYMT_AMT',
            'Payment Amounts',
            'PBM_LIAB_PYMT_VIEWER_PLUGIN',
          ),
        icon: fas.faListUl,
      },
      {
        name: 'Payment Adjustments',
        action: () =>
          entityPerspectiveRef.current.navigateToViewer(
            params,
            'PYMT_ADJ',
            'Payment Adjustments',
            'PBM_LIAB_PYMT_ADJ_VIEWER_PLUGIN',
          ),
        icon: fas.faListUl,
      },
    ];

    contextMenus.push(
      {
        name: 'Payment Transaction Details',
        subMenu: pymtItems,
        icon: fas.faListUl,
      },
      {
        name: 'Forecasted Liability',
        action: () =>
          entityPerspectiveRef.current.navigateToPerspectiveAdj(params, 'FORECASTED_LIAB', 'Forecasted Liability'),
        icon: fas.faSlidersH,
      },
      {
        name: 'Liability Adjustments',
        action: () =>
          entityPerspectiveRef.current.navigateToPerspectiveAdj(params, 'LIAB_ADJ', 'Liability Adjustments'),
        icon: fas.faSlidersH,
      },
    );

    return contextMenus;
  };

  const augButtons = (buttons) => {
    buttons.push(
      <MassOverwriteButton
        role={'GTN_FORECASTED_LIAB_SAVE'}
        toolTip={'Adjust Forecasted Liability'}
        kpiCodes={['FORECASTED_LIAB']}
        entity={entity}
        defaultDimValues={{ OVER_UNDER_SCEN: overUnderScenId }}
      />,
    );
    buttons.push(
      <MassOverwriteButton
        role={'GTN_LIAB_ADJ_SAVE'}
        toolTip={'Liability Adjustment'}
        kpiCodes={['LIAB_ADJ']}
        entity={entity}
        defaultDimValues={{ OVER_UNDER_SCEN: overUnderScenId }}
      />,
      <TitleButtonDivider key="filterButtonDivider" />,
    );
  };

  return (
    <EntityPerspective
      ref={entityPerspectiveRef}
      views={views}
      defaultDimFilters={defaultDimFilters}
      augButtons={augButtons}
      entity={entity}
      gridOptions={{
        getContextMenuItems,
      }}
    />
  );
};
